import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { CalendarLockMark } from '../calendar-lock-mark'
import type { LockedCalendarItemProps } from './locked-calendar-item.interface'
import classes from './locked-calendar-item.module.scss'

export function LockedCalendarItem({ calendar, upgradePath, className }: LockedCalendarItemProps) {
  return (
    <Link
      to={upgradePath}
      className={classNames(classes.item, className)}
      title={calendar.title}
      data-testid="locked-calendar-item"
    >
      <CalendarLockMark />
      <span className={classes.title}>{calendar.title}</span>
    </Link>
  )
}
